import Flex from "../../../../designComponents/Flex";
import Typography from "../../../../designComponents/Typography";

type Props = {
  additionalQuestions: string[];
};

const PropertyAdditionalQuestionsViewer = ({ additionalQuestions }: Props) => {
  if (additionalQuestions?.length === 0 || !additionalQuestions) {
    return null;
  }
  return (
    <Flex direction="column" gap={"20px"}>
      {additionalQuestions?.map((q, i) => {
        return (
          <Typography key={q}>
            {i + 1}. {q}
          </Typography>
        );
      })}
    </Flex>
  );
};

export default PropertyAdditionalQuestionsViewer;
